export default "__VITE_ASSET__Bih$AIcY__"